import * as THREE from 'three';
import p5 from "p5";
import { QTreeRect } from './QTreeRect';
import { Params } from '../../data/Params';
import { Random } from '../../data/Random';
import { Utils } from '../../data/Utils';


export class QTree {

    _p5         :p5;
    _width      :number = 512;
    _height     :number = 512;
    _maxDepth   :number = 0;
    public rects       :QTreeRect[];

    constructor(){

    }

    update(depth:number){

        this.rects = [];
        this._maxDepth = depth;
        this.split(0,0,this._width,this._height,0);
        //this.swapRandomly(0.2);
        
        Utils.swapRandomly(this.rects,0.2);
    }

   

    split(
        xx:number,yy:number,ww:number,hh:number,depth:number
    ){

        if(
            depth>=this._maxDepth || (Random.value<depth*0.2 && depth>=1)
        ){
            let qtree= new QTreeRect(xx,yy,ww,hh,depth);
            //qtree.setRule( Params.rules[depth] );//this.rects.length%Params.rules.length]
            qtree.setRule( 
                Params.rules[Math.floor(Random.value*Params.rules.length)]
            );//this.rects.length%Params.rules.length]

            this.rects.push(qtree);
            return;
        }

        let ratioX = 0.5;
        let ratioY = 0.5;
        
        let w = ww * ratioX;
        let h = hh * ratioY;
        let next = depth+1;

        this.split(xx,yy,w,h,next);//
        this.split(xx+w,yy,w,h,next);//
        this.split(xx,yy+h,w,h,next);//
        this.split(xx+w,yy+h,w,h,next);//
        
    }


}